import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { X } from "lucide-react";

const JustificationModal = ({ isOpen, onClose, onSubmit, isEdit = false, initialData = null }) => {
  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();

  useEffect(() => {
    if (isOpen && initialData) {
      setValue("justificationText", initialData.justificationText);
    } else if (isOpen) {
      reset();
    }
  }, [isOpen, initialData, setValue, reset]);

  const handleFormSubmit = (data) => {
    onSubmit(data);
    reset();
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-11/12 md:w-2/3 lg:w-1/2 overflow-hidden rounded shadow-lg relative">
        <div className="flex justify-between items-center border-b pb-2 px-4 pt-4">
          <h2 className="text-xl font-semibold">
            {isEdit ? "Edit Justification" : "Submit Justification"}
          </h2>
          <button className="p-2 hover:bg-gray-200 rounded-full" onClick={handleClose}>
            <X />
          </button>
        </div>
        <div className="overflow-y-auto px-6 py-4">
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Justification Text
              </label>
              <textarea
                {...register("justificationText", { 
                  required: "Justification text is required",
                  minLength: {
                    value: 10,
                    message: "Justification must be at least 10 characters long"
                  }
                })}
                className="w-full border rounded p-3 h-32 resize-none"
                placeholder="Please provide your justification for this warning..."
                rows={4}
              />
              {errors.justificationText && (
                <p className="text-red-500 text-sm mt-1">{errors.justificationText.message}</p>
              )}
            </div>
            
            <div className="flex justify-end gap-4">
              <button 
                type="button" 
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400" 
                onClick={handleClose}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="bg-[#241763] text-white px-4 py-2 rounded hover:bg-[#1a0f4a]"
              >
                {isEdit ? "Update Justification" : "Submit Justification"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default JustificationModal;
